import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { displayCurrency, displayDate } from '@/utils/format.utils';
import { getBenefactor, getOrderStatusVariant, getOutstanding, getTotalPaid } from '@/utils/order.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { ModelOrderResponse } from '@layup/api-sdk';

export const cancellationsTableColumns: ColumnDef<ModelOrderResponse>[] = [
  {
    accessorKey: 'customerName',
    header: 'Customer Name',
    enableSorting: false,
    cell: ({ row }) => {
      const order: ModelOrderResponse = row.original;
      return h('div', { class: 'font-medium' }, getBenefactor(order)?.name ?? 'N/A');
    },
  },
  {
    accessorKey: 'name',
    header: 'Order Name',
    enableSorting: false,
    cell: ({ row }) => {
      const name = row.original.name;
      const id = row.original._id;
      return h(RouterLink, { to: `/merchant/orders/${id}`, class: 'font-medium text-brand-700 underline' }, () => name);
    },
  },
  {
    accessorKey: 'reference',
    header: 'Order Reference',
    enableSorting: false,
    cell: ({ getValue }) => {
      const ref = getValue() as string;
      return h('div', ref);
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Date Created',
    enableSorting: false,
    cell: ({ getValue }) => {
      const createdAt = getValue() as string;
      return h('div', displayDate(createdAt));
    },
  },
  {
    accessorKey: 'plans',
    header: 'Plan Value',
    enableSorting: false,
    cell: ({ row }) => {
      const order: ModelOrderResponse = row.original;
      const planValue = order.plans
        ? order.plans.reduce((s, p: any) => s + p.amountDueExcludingFee + p.depositDueExcludingFee, 0)
        : 0;

      return h('div', displayCurrency(planValue));
    },
  },
  {
    accessorKey: 'plans',
    header: 'Outstanding',
    enableSorting: false,
    cell: ({ row }) => {
      const order: ModelOrderResponse = row.original;
      return h('div', displayCurrency(getOutstanding(order)));
    },
  },
  {
    accessorKey: 'plans',
    header: 'Total Received',
    enableSorting: false,
    cell: ({ row }) => {
      const order: ModelOrderResponse = row.original;
      return h('div', displayCurrency(getTotalPaid(order)));
    },
  },
  {
    accessorKey: 'endDateMax',
    header: 'Date Created',
    enableSorting: false,
    cell: ({ getValue }) => {
      const endDateMax = getValue() as string;
      return h('div', displayDate(endDateMax));
    },
  },
  {
    accessorKey: 'state',
    header: 'Status',
    enableSorting: false,
    cell: ({ getValue }) => {
      const status = getValue() as string;
      const variant = getOrderStatusVariant(status);
      return h(Badge, { class: 'text-xs', variant }, status);
    },
  },
];
